module.exports = __webpack_public_path__ + "img/6.cdb30369.jpg";